export default function divider() {
  return {
    _id: false,
    type: 'droplet.divider',
    mediaQueries: [
      {
        selector: '.drz-hr',
        properties: [
          {
            property: 'border-color',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
    ],
    pageCSS: '',
    bounceDroplet: false,
    isShared: false,
    templateRegion: false,
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/divider/droplet.schema.js